import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface PriceComparisonsViewedEventProperties {
  sellable_id: string
  sale_price: string
  price_comparisons: {
    source: string
    price: string
  }[]
}

export class PriceComparisonsViewedEvent extends Event<PriceComparisonsViewedEventProperties> {
  static displayName = 'Price Comparisons Viewed'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
